const translations = {
  menuEinvoice: {
    lookUp: "Buscar",
    documents: "Documentos",
    edocuments: "E-documentos",
    customers: "Clientes",
    settings: "Configuración",
    integrations: "Integraciones"
  }
};

export default translations;
